import { fabric } from 'fabric';
import lottie from 'lottie-web';

/**
 * Symbol object class
 *
 */
const LudusLottie = fabric.util.createClass(fabric.Group, {
  type: 'ludusLottie',
  lockUniScaling: true,
  lockScalingFlip: true,

  initialize(options = {}) {
    this.previewImage = new fabric.ImageAsync(
      options.src,
      {
        originX: 'center',
        originY: 'center',
        width: options.width,
        height: options.height,
        src: options.src,
      },
      null,
      LudusLottie.initAsyncContent,
    );
    this.callSuper('initialize', [this.previewImage], options);
  },

  /**
   * Override fabric.Group.toObject() to include the reference
   *
   * @returns {Object}
   */
  toObject(propertiesToInclude = []) {
    const extraProps = ['src'];
    const object = this.callSuper(
      'toObject',
      propertiesToInclude.concat(extraProps),
    );
    delete object.objects;

    return object;
  },
});

LudusLottie.fromObject = (object, callback) => {
  const options = fabric.util.object.clone(object, true);

  if (callback) {
    callback(new LudusLottie(options));
  }
};

LudusLottie.initAsyncContent = (options, callback) => {
  const { src } = options;
  const container = document.createElement('div');
  document.getElementById('offscreen-container').appendChild(container);

  const animation = lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: src,
  });

  animation.addEventListener('DOMLoaded', () => {
    options.width = animation.animationData.w;
    options.height = animation.animationData.h;
    try {
      animation.goToAndStop(Math.round(animation.totalFrames / 2), false);
      const svg = new Blob([animation.wrapper.innerHTML], {
        type: 'image/svg+xml',
      });
      const dataUrl = URL.createObjectURL(svg);
      fabric.util.loadImage(dataUrl, image => {
        if (callback) {
          callback(image);
        }
      });
    } catch (error) {
      console.error(error);
    }
  });
};

export default LudusLottie;
